module.exports = __webpack_public_path__ + "static/media/img-fondo-casos-clinicos.9a074ea7.png";